import * as utils from "../../utils/utils.js";

export default function () {
  const widgetName = "sFloridaMainFeature";
  const widgetOpts = sFloridaMainFeatureOpts;

  const swiperContainers = `
    <div class="swiper-container swiper-container-images">
      <div class="swiper-wrapper">
      </div>
    </div>
    <div class="wraper-container">
      <div class="outer-container">
        <div class="inner-container">
          <div class="slide-content-wraper">
            <div class="swiper-container swiper-container-content">
              <div class="swiper-wrapper"></div>
            </div>
          </div>
        </div>
        <div class="nav-container">
          <div class="swiper-button-prev"></div>
          <div class="swiper-pagination"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
    </div>`;

  // Slide Template - Images
  function buildSlideTemplateImages(slide) {
    const template = `
        <div class="swiper-slide">
          <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
            <div class="swiper-lazy-preloader"></div>
          </div>
        </div>`;

    return template;
  }

  // Slide Template - Content
  function buildSlideTemplateContent(slide) {
    const ticketShapeSmall = `
    <svg xmlns="http://www.w3.org/2000/svg" width="134" height="53" viewBox="0 0 134 53">
      <path class="cls-1" d="M2666,611h102l15,12v26l-15,12H2666l-14-12V623Z" transform="translate(-2650.5 -609.5)" />
    </svg>
    `;

    const ticketShapeLarge = `
    <svg xmlns="http://www.w3.org/2000/svg" width="149" height="53" viewBox="0 0 149 53">
      <path class="cls-1" d="M2804,611h117l15,12v26l-15,12H2804l-14-12V623Z" transform="translate(-2788.5 -609.5)" />
    </svg>
    `;

    const title = `<h2 class="slide-title">${slide.Title}</h2>`;
    const description = `<p class="slide-description">${slide.Description}</p>`;

    const buttons = function (btn1, btn1Text, btn2, btn2Text) {
      if (btn1 || btn2) {
        let btnContainer = $('<div class="button-container"></div>');
        if (btn2) {
          btnContainer.append(
            `<a href="${btn2}" class="button" ${
              utils.isLocalUrl(btn2) ? "" : "target='_blank'"
            }>${btn2Text}</a>`
          );
        }
        if (btn1) {
          btnContainer.append(
            `<a href="${btn1}" class="button" ${
              utils.isLocalUrl(btn1) ? "" : "target='_blank'"
            }>${btn1Text}</a>`
          );
        }
        return btnContainer.prop("outerHTML");
      } else {
        return "";
      }
    };

    const template = `
        <div class="swiper-slide">
          <div class="swiper-content-container">
            ${title}
            ${description}
            ${buttons(
              slide.PurchaseURL,
              slide.PurchaseLinkText,
              slide.URL,
              slide.DetailLinkText
            )}
          </div>
        </div>`;

    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetImagesWrapper = $(
      `#${widgetName} .swiper-container-images .swiper-wrapper`
    );
    const swiperWidgetContentWrapper = $(
      `#${widgetName} .swiper-container-content .swiper-wrapper`
    );

    widgetData.forEach(function (slide, i) {
      swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
      swiperWidgetContentWrapper.append(buildSlideTemplateContent(slide));
    });

    const swiperWidgetImages = new Swiper(
      `#${widgetName} .swiper-container-images`,
      {
        speed: 600,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
        loop: widgetData.length > 1,
        watchOverflow: true,
        spaceBetween: 0,
        centeredSlides: false,
        preloadImages: false,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
        slidesPerView: "auto",
        a11y: true,
        autoHeight: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          nextEl: `#${widgetName} .swiper-button-next`,
          prevEl: `#${widgetName} .swiper-button-prev`,
        },
        pagination: {
          el: `#${widgetName} .swiper-pagination`,
          clickable: true,
        },
      }
    );

    const swiperWidgetContent = new Swiper(
      `#${widgetName} .swiper-container-content`,
      {
        speed: 600,
        spaceBetween: 0,
        centeredSlides: false,
        loop: widgetData.length > 1,
        watchOverflow: true,
        a11y: true,
        autoHeight: true,
        slidesPerView: "auto",
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
      }
    );
    swiperWidgetImages.controller.control = swiperWidgetContent;
    swiperWidgetContent.controller.control = swiperWidgetImages;
  }
  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
    } else {
      console.log(response);
      console.log("Error: No Data for swiperWidget");
    }
  });
}
